import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "table" }
const _hoisted_5 = { class: "drawer-contain" }
const _hoisted_6 = { class: "drawer-header" }
const _hoisted_7 = { class: "drawer-header-lt" }
const _hoisted_8 = { class: "drawer-lt-title" }
const _hoisted_9 = { class: "drawer-header-rt" }
const _hoisted_10 = { class: "drawer-rt-btns" }
const _hoisted_11 = { class: "drawer-info" }
const _hoisted_12 = { class: "drawer-desc" }
const _hoisted_13 = { class: "work-level" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_More = _resolveComponent("More")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_Back = _resolveComponent("Back")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          inline: true,
          model: _ctx.formSearch,
          class: "demo-form-inline"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "操作属性" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.formSearch.operationType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formSearch.operationType) = $event)),
                  placeholder: "请选择状态",
                  clearable: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.operationTypeList, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        label: item.label,
                        value: index,
                        key: index
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "操作时间" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.formSearch.projectTime,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formSearch.projectTime) = $event)),
                  type: "daterange",
                  class: "date-solt point",
                  "unlink-panels": "",
                  "range-separator": "至",
                  "start-placeholder": "开始日期",
                  "end-placeholder": "截止日期",
                  format: "YYYY-MM-DD",
                  "value-format": "YYYY-MM-DD",
                  style: {"width":"241px","margin-right":"20px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.onSearch
                }, {
                  default: _withCtx(() => _cache[7] || (_cache[7] = [
                    _createTextVNode("搜索")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_button, { onClick: _ctx.onReset }, {
                  default: _withCtx(() => _cache[8] || (_cache[8] = [
                    _createTextVNode("重置")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_table, {
          data: _ctx.tableData,
          style: {"width":"100%","min-height":"550px"},
          "header-cell-style": { background: '#FBFBFD' },
          "header-row-style": { color: '#202536' },
          "row-style": { color: '#5E617D' },
          onSelectionChange: _ctx.handleSelectionChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, { label: "操作属性" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.onClickType(scope.row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.formatter(scope.row.operationType,_ctx.operationTypeList,{
    valueKey: 'value'
  })), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "total",
              label: "数量"
            }),
            _createVNode(_component_el_table_column, {
              prop: "companyPlanName",
              label: "保险商品"
            }),
            _createVNode(_component_el_table_column, {
              prop: "updateTime",
              label: "操作时间"
            }),
            _createVNode(_component_el_table_column, {
              prop: "managerName",
              label: "操作人"
            }),
            _createVNode(_component_el_table_column, { label: "操作" }, {
              default: _withCtx((scope) => [
                _createVNode(_component_el_button, {
                  type: "text",
                  onClick: ($event: any) => (_ctx.onExport(scope.row.id))
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("导出")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "onSelectionChange"]),
        _createVNode(_component_el_pagination, {
          class: "pagination",
          currentPage: _ctx.pageNum,
          "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageNum) = $event)),
          "page-size": _ctx.pageSize,
          "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.pageSize) = $event)),
          "page-sizes": [10, 30, 50, 100],
          layout: "total, sizes, prev, pager, next, jumper",
          total: _ctx.total,
          onSizeChange: _ctx.handleSizeChange,
          onCurrentChange: _ctx.initTableList
        }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
      ])
    ]),
    _createVNode(_component_el_drawer, {
      modelValue: _ctx.showDrawer,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showDrawer) = $event)),
      size: "70%",
      "with-header": false,
      "show-close": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.formatter(_ctx.rowObj.operationType,_ctx.operationTypeList,{  valueKey: 'value'})), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_dropdown, { trigger: "click" }, {
                  dropdown: _withCtx(() => [
                    _createVNode(_component_el_dropdown_menu, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_dropdown_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "text",
                              onClick: _ctx.onDetailExport
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("导出")
                              ])),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, { size: "small" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_More)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  class: "mg-l-20",
                  size: "small",
                  onClick: _ctx.goBack
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Back)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "drawer-rt-back" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createTextVNode("操作时间 ")),
              _createElementVNode("span", null, _toDisplayString(_ctx.rowObj.updateTime), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_el_table, {
                data: _ctx.tablePeopleList,
                style: {"width":"100%","min-height":"550px"},
                border: "",
                "header-cell-style": { background: '#FBFBFD' },
                "header-row-style": { color: '#202536' },
                "row-style": { color: '#5E617D' },
                onSelectionChange: _ctx.handleSelectionChange
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    prop: "userName",
                    label: "用户姓名"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "idCardNo",
                    label: "身份证号"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "companyPlanName",
                    label: "保险商品"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "serveCompanyName",
                    label: "派遣单位"
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "occupationName",
                    label: "保障工种"
                  }),
                  (_ctx.rowObj.operationType==0)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "insureStartTime",
                        label: "保单生效时间"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.rowObj.operationType==0)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        prop: "insureEndTime",
                        label: "保单截止时间"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.rowObj.operationType!=0)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 2,
                        prop: "insureEndTime",
                        label: "保单截止时间"
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.rowObj.operationType!=0)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 3,
                        prop: "beforeInsureEndTime",
                        label: "前保单截止时间"
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data", "onSelectionChange"]),
              _createVNode(_component_el_pagination, {
                class: "pagination",
                currentPage: _ctx.pagePeopleNum,
                "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.pagePeopleNum) = $event)),
                "page-size": _ctx.pagePeopleSize,
                "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.pagePeopleSize) = $event)),
                "page-sizes": [10, 30, 50, 100],
                layout: "total, sizes, prev, pager, next, jumper",
                total: _ctx.totalPeople,
                onSizeChange: _ctx.handleSizeChange,
                onCurrentChange: _ctx.initPeopleList
              }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}